// src/components/ProductList.tsx
import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { AlertTriangle, Loader2 } from 'lucide-react';
import { ProductCard } from './ProductCard'; // Adjust path if needed
import { Product } from '../types/Product'; // Import Product interface from new location

export const ProductList = ({
  products,
  onEdit,
  onDelete,
  isLoading,
  error,
}: {
  products: Product[];
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
  isLoading: boolean;
  error: string | null;
}) => {
  if (isLoading) {
    return (
      <div className="loading-container">
        <Loader2 className="loading-icon" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-message" role="alert">
        <strong className="error-bold">Error: </strong>
        <span className="error-text">{error}</span>
        <AlertTriangle className="icon" />
      </div>
    );
  }

  if (products.length === 0) {
    return <p className="no-products-message">No products found.</p>;
  }

  return (
    <div className="product-grid">
      <AnimatePresence>
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};
